'use client';
import React from 'react';
import { useEvent } from '@/lib/eventContext';
import { AlertTriangle } from 'lucide-react';

export default function EventSwitchModal() {
  const { pendingEvent, confirmEventSwitch, cancelEventSwitch } = useEvent();

  if (!pendingEvent) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center" style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
      <div className="rounded-xl border border-wt-border p-6 w-full max-w-sm animate-slide-up" style={{ background: '#0d1520', boxShadow: '0 30px 60px rgba(0,0,0,0.8)' }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center">
            <AlertTriangle size={20} className="text-yellow-400" />
          </div>
          <div>
            <h3 className="text-sm font-600 text-wt-text">Event wisselen</h3>
            <p className="text-xs text-wt-muted">Bevestig de wijziging</p>
          </div>
        </div>
        <p className="text-sm text-wt-text-dim mb-1">
          Je staat op het punt van event te wisselen naar:
        </p>
        <p className="text-sm font-600 text-wt-primary mb-4">{pendingEvent?.name}</p>
        <p className="text-xs text-wt-muted mb-6">
          Alle weergegeven data wordt gefilterd op het nieuwe event. Niet-opgeslagen wijzigingen gaan verloren.
        </p>
        <div className="flex gap-3">
          <button
            onClick={cancelEventSwitch}
            className="flex-1 px-4 py-2 rounded-lg border border-wt-border text-sm text-wt-text hover:bg-wt-elevated transition-colors"
          >
            Annuleren
          </button>
          <button
            onClick={confirmEventSwitch}
            className="flex-1 px-4 py-2 rounded-lg bg-wt-primary text-white text-sm font-medium hover:bg-sky-400 transition-colors"
          >
            Doorgaan
          </button>
        </div>
      </div>
    </div>
  );
}